import React, { useEffect, useState } from "react";
import "../styles/footer.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFetch } from "./fetch";
import { config } from "./config";
import { triggerVibration } from "../utilities/validation";
import { FooterSkeleton } from "./skeleton";
import { ChevronDown, ChevronUp } from "lucide-react";
const Footer = () => {
  const [categories, setCategories] = useState([]);
  const [expandedCategory, setExpandedCategory] = useState(null);

  const {
    data: category,
    isLoading,
    isError,
  } = useFetch("api/categories", config.serverURL); // Calls `/product/:id`
  // State for toggling the side panel visibility
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  // State for tracking the active section
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    if (category) {
      setCategories(category);
    }
  }, [category]);

  // Open panel handler
  const openPanel = () => {
    triggerVibration(100);
    setIsPanelOpen(true);
    setActiveSection("categories");
  };

  // Close panel handler
  const closePanel = () => {
    setIsPanelOpen(false);
  };
  const navigate = useNavigate();

  // Navigate to the category page
  const handleNavCategory = (categoryName) => {
    // Navigate to the brand page for the selected category
    navigate(`/category/${categoryName}`);
  };
  // Directly accessing state without an explicit selector
  const totalItems = useSelector((state) => state.cart.totalQuantity);
  if (isLoading) return <FooterSkeleton />; // Show loading state while fetching
  if (isError) return <div>Error fetching categories</div>; // Handle error

  const toggleExpand = (id) => {
    //console.log(id);
    setExpandedCategory(expandedCategory === id ? null : id);
  };

  return (
    <div>
      {/* Fixed bottom bar */}
      <div className="fixed-bottom-bar">
        <div
          className={`footer-home ${activeSection === "home" ? "active" : ""}`}
          onClick={() => {
            setActiveSection("home");
            triggerVibration(100);
          }}
        >
          <i className="pi pi-home" aria-hidden="true"></i>
          <span>Home</span>
        </div>
        <div
          className={`category-section ${
            activeSection === "categories" ? "active" : ""
          }`}
          onClick={openPanel}
        >
          <i className="fa fa-list" aria-hidden="true"></i>
          <span>Categories</span>
        </div>

        <div
          className={`offers-section ${
            activeSection === "offers" ? "active" : ""
          }`}
          onClick={() => {
            setActiveSection("offers");
            triggerVibration(100);
          }}
        >
          <i className="pi pi-tags" aria-hidden="true"></i>
          <span>Offers</span>
        </div>
        {/* {activeSection === "offers" && <BrandList />} */}
        <div
          className={`cart-section ${activeSection === "cart" ? "active" : ""}`}
          onClick={() => {
            triggerVibration(100);
            setActiveSection("cart");
            navigate("/cart"); // Navigate to the Cart page
          }}
        >
          <i className="pi pi-cart-arrow-down"></i>
          <span className="cart-text">Cart</span>
          <span
            className={`cart-counter ${
              totalItems > 0 ? "show-cart-counter" : ""
            }`}
            style={{ display: totalItems === 0 ? "none" : "flex" }}
          >
            {totalItems}
          </span>
        </div>
      </div>

      {/* Side sliding panel */}
      {isPanelOpen && (
        <div
          className={`side-panel ${isPanelOpen ? "open" : ""}`}
          id="categoryPanel"
        >
          <div className="panel-header">
            <span>Categories</span>
            <button className="close-btn" onClick={closePanel}>
              X
            </button>
          </div>
          <div className="panel-content b bg-list-group">
            {/* {category && category.length > 0 ? (
              category.map((cat) => (
                <div
                  className="d-flex justify-center align-center bb-1 border-bbb w-100"
                  onClick={() => toggleExpand(cat.id)}
                >
                  <span
                    className="fc-1 b fs-1 text-cap"
                    key={cat.id}
                    onClick={() => handleNavCategory(cat.mastername)}
                  >
                    {cat.mastername}
                  </span>
                  <span>
                    {expandedCategory === cat.id ? (
                      <ChevronUp className="chevron-icon" />
                    ) : (
                      <ChevronDown className="chevron-icon" />
                    )}
                  </span>
                  {expandedCategory === cat.id && cat.brands.length > 0 && (
                    <div className="brand-list pl-3 text-cap">
                      {cat.brands.map((brand, index) => (
                        <div key={index} className="brand-item fc-2 fs-2">
                          {brand}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <span>No categories available</span>
            )} */}
            {categories && categories.length > 0 ? (
              categories.map((cat) => (
                <div key={cat.id} className="w-100 ">
                  {/* Category Row */}
                  <div
                    className="d-flex justify-between align-center bb-1 border-bbb w-100 p-5 box-sizing"
                    onClick={() => toggleExpand(cat.id)}
                  >
                    <span className="fc-1  fs-0-75 text-cap" onClick={() => handleNavCategory(cat.mastername)}>
                      {cat.mastername}
                    </span>
                    <span>
                      {expandedCategory === cat.id ? (
                        <ChevronUp className="chevron-icon" size={12} />
                      ) : (
                        <ChevronDown className="chevron-icon" size={12} />
                      )}
                    </span>
                  </div>

                  {/* Expanded Brands List */}
                  {expandedCategory === cat.id && cat.brands.length > 0 && (
                    <div className="d-flex justify-start align-center gap-01 p-5 flex-wrap ">
                      {cat.brands.map((brand, index) => (
                        <div
                          key={index}
                          className="fs-0-75 b-1 br-4 p-02 bg-white border-primary text-cap"
                          onClick={() => navigate(`/brand/${brand.name}`)}
                        >
                          <div className="d-flex flex-dir-col bg-white justify-center align-center">
                            <span
                              style={{
                                width: "4rem",
                                height: "3rem",
                                backgroundColor: "white",
                                fontSize: "0.675rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                wordBreak: "break-word",
                                lineHeight: "1",
                              }}
                            >
                              {brand.imageUrl !== "" ? (
                                <img
                                  src={brand.imageUrl}
                                  alt={brand.name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    padding: "0",
                                  }}
                                />
                              ) : (
                                <span
                                  style={{
                                    wordBreak: "break-word",
                                    textAlign: "center",
                                  }}
                                >
                                  {brand.name}
                                </span>
                              )}
                            </span>
                            
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <span>No categories available</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
